import { useCommunityFetcher } from './useCommunityFetcher';

export const SET_COMMENTS_STATE_ACTION = '/community_post_comments_state';

export const setCommentsStateFetcherKey = (postId: string): string => `set-community-post-comments-state-${postId}`;

/**
 * Subscribes to the shared keyed fetcher used for setting a community post's
 * comments_state (open/closed/hidden). Submission must use { method: 'PATCH',
 * action: SET_COMMENTS_STATE_ACTION } so consumers can detect in-flight state
 * via `isSubmitting`.
 *
 * On idle transition the centralized `useCommunityFetcher` invalidates the
 * `['community-posts']` query (refreshing the feed) and surfaces the success
 * or error toast returned by the action.
 */
export const useSetCommentsStateFetcher = (
  postId: string,
  { onSubmissionComplete }: { onSubmissionComplete?: () => void } = {},
) => {
  const { fetcher } = useCommunityFetcher(setCommentsStateFetcherKey(postId), {
    queryKey: ['community-posts'],
    onSubmissionComplete,
  });
  const isSubmitting = fetcher.state !== 'idle' && fetcher.formAction === SET_COMMENTS_STATE_ACTION;
  return { fetcher, isSubmitting };
};
